<div cms-not-replace class="sk-cms-login sk-cms-login-wap {{isPreview ? '': 'sk-component REGISTRATION'}}" sk-class="$data.isNavShow ? 'nav-login': ''"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    <div class="login-main">
        {{if style.person.styleType !== "hide"}}
        <div class="items-wap" sk-if="$data.isLogin">
            <a class="wap-link goto-link" {{isDesign ? '' : 'sk-prop.href=$data.userLink'}} cms-not-replace>
                <img src="{{content.person.icon.src ? content.person.icon.src : '../../assets/images/icons01.png'}}" sk-if="!$data.headImgUrl" cms-smarket cms-not-replace/>
                <img sk-prop.src="$data.headImgUrl" sk-if="$data.headImgUrl"/>
            </a>
        </div>
        <div class="items-wap" sk-if="!$data.isLogin">
            <a class="wap-link goto-link"  {{isDesign ? '' : 'sk-prop.href=$data.link'}} cms-not-replace>
                <img src="{{'../../assets/images/icons01.png'}}" cms-smarket/>
            </a>
        </div>
        {{/if}}
    </div>
</div>
